import StarterKit from '@tiptap/starter-kit'
import { Link } from '@tiptap/extension-link'
import Image from 'tiptap-extension-resize-image'
import { Table } from '@tiptap/extension-table'
import { TableRow } from '@tiptap/extension-table-row'
import { TableHeader } from '@tiptap/extension-table-header'
import { TableCell } from '@tiptap/extension-table-cell'
import { Underline } from '@tiptap/extension-underline'
import { Subscript } from '@tiptap/extension-subscript'
import { Superscript } from '@tiptap/extension-superscript'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import { Highlight } from '@tiptap/extension-highlight'
import { TextAlign } from '@tiptap/extension-text-align'
import { Mark } from '@tiptap/core'

export const FontSize = Mark.create({
    name: 'fontSize',
    addAttributes() {
        return {
            fontSize: {
                default: null,
                parseHTML: element => element.style.fontSize || element.getAttribute('data-font-size') || null,
                renderHTML: attributes => {
                    if (!attributes.fontSize) {
                        return {}
                    }
                    return {
                        'data-font-size': attributes.fontSize,
                        style: `font-size: ${attributes.fontSize}`
                    }
                }
            }
        }
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-font-size]'
            },
            {
                style: 'font-size'
            }
        ]
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', HTMLAttributes, 0]
    }
})

export const CustomTableCell = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            backgroundColor: {
                default: null,
                parseHTML: element => element.getAttribute('data-background-color') || element.style.backgroundColor,
                renderHTML: attributes => {
                    if (!attributes.backgroundColor) {
                        return {}
                    }
                    return {
                        'data-background-color': attributes.backgroundColor,
                        style: `background-color: ${attributes.backgroundColor}`
                    }
                }
            }
        }
    }
})

export const CustomTableHeader = TableHeader.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            backgroundColor: {
                default: null,
                parseHTML: element => element.getAttribute('data-background-color') || element.style.backgroundColor,
                renderHTML: attributes => {
                    if (!attributes.backgroundColor) {
                        return {}
                    }
                    return {
                        'data-background-color': attributes.backgroundColor,
                        style: `background-color: ${attributes.backgroundColor}`
                    }
                }
            }
        }
    }
})

export const CustomTable = Table.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            borderColor: {
                default: null,
                parseHTML: element => element.getAttribute('data-border-color'),
                renderHTML: attributes => {
                    if (!attributes.borderColor) {
                        return {}
                    }
                    return {
                        'data-border-color': attributes.borderColor,
                        style: `--table-border-color: ${attributes.borderColor}`
                    }
                }
            }
        }
    }
})

export function buildRichTextAreaExtensions() {
    return [
        StarterKit,
        Underline,
        Link.configure({
            openOnClick: false
        }),
        Image.configure({
            allowBase64: true,
        }),
        CustomTable.configure({
            resizable: true
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        Subscript,
        Superscript,
        TextStyle,
        FontSize,
        Color,
        Highlight.configure({
            multicolor: true
        }),
        TextAlign.configure({
            types: ['heading', 'paragraph']
        })
    ]
}



